import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useCallback, useEffect, useRef, useState, } from 'react';
import usePointerClick from '../../utils/usePointerClick';
const overlayStyles = css `
  background-color: rgba(250, 250, 250, 0.9);
  height: 100%;
  position: absolute;
  width: 100%;
  opacity: 0;
`;
const interactiveOverlayStyles = css `
  opacity: 1;
`;
const hiddenChildrenStyles = css `
  display: none;
`;
const interactiveChildrenStyles = css `
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  width: 100%;
`;
const ProductCellOverlay = ({ children, windowContexts = [
    window,
], }) => {
    const overlayRef = useRef(null);
    const [isOverlayVisible, setIsOverlayVisible,] = useState(false);
    const [isChildrenVisible, setIsChildrenVisible,] = useState(false);
    const toggleOverlay = useCallback((event) => {
        if (event.pointerType === 'touch') {
            if (isOverlayVisible && event.target === overlayRef.current) {
                setIsOverlayVisible(false);
            }
            else if (!isOverlayVisible) {
                setIsOverlayVisible(true);
            }
        }
    }, [
        isOverlayVisible,
        setIsOverlayVisible,
    ]);
    // We need this to display the children at a slight delay from the overlay container to prevent firing a child's click event if applicable
    useEffect(() => {
        const timeoutId = (isOverlayVisible
            ? (setTimeout(() => {
                setIsChildrenVisible(true);
            }))
            : setIsChildrenVisible(false));
        return () => {
            clearTimeout(timeoutId);
        };
    }, [
        isOverlayVisible,
        setIsChildrenVisible,
    ]);
    const onPointerClick = usePointerClick(toggleOverlay);
    useEffect(() => {
        if (!isOverlayVisible) {
            return () => { };
        }
        const callback = (event) => {
            if (overlayRef.current
                && !(overlayRef.current.contains(event.target))) {
                setIsOverlayVisible(false);
            }
        };
        windowContexts
            .forEach((bodyElement) => {
            bodyElement.addEventListener('pointerdown', callback);
        });
        return () => {
            windowContexts
                .forEach((bodyElement) => {
                bodyElement.removeEventListener('pointerdown', callback);
            });
        };
    }, [
        windowContexts,
        isOverlayVisible,
        setIsOverlayVisible,
    ]);
    const onPointerEnter = useCallback((event) => {
        if (event.pointerType !== 'touch') {
            setIsOverlayVisible(true);
        }
    }, [
        setIsOverlayVisible,
    ]);
    const onPointerLeave = (useCallback((event) => {
        if (event.pointerType !== 'touch') {
            setIsOverlayVisible(false);
        }
    }, [
        setIsOverlayVisible,
    ]));
    return (_jsx("div", Object.assign({ css: css `
          ${overlayStyles}
          ${isOverlayVisible && interactiveOverlayStyles}
        `, onPointerDown: onPointerClick, onPointerEnter: onPointerEnter, onPointerLeave: onPointerLeave, ref: overlayRef }, { children: _jsx("div", Object.assign({ css: isChildrenVisible
                ? interactiveChildrenStyles
                : hiddenChildrenStyles }, { children: children })) })));
};
const MemoizedProductCellOverlay = memo(ProductCellOverlay);
export { MemoizedProductCellOverlay as ProductCellOverlay };
// MC-1068 Temporary hack for Storybook.
export default ProductCellOverlay;
